<script>
import ModelEdit from '../models/edit-v2';
import FormsModel from "@/components/forms/unload";
import { serialize } from "object-to-formdata";
import Swal from 'sweetalert2';
import SaleOrderService from "@/services/SaleOrderService";
import SuccessModal from "@/router/views/unload/components/modals/SuccessModal.vue";

export default {
    extends: ModelEdit,
    page: {
        title: "Edit Nota Bongkar",
    },
    components: {
        SuccessToUpdateModal: SuccessModal,
    },
    props: {
      cardTitle: { default() { return "Nota Bongkar" } },
      resourceRoute: { default: 'unload' },
      modelVariable: { default: 'unload' },
      form: { default() { return FormsModel; } },
      alerts: {default: () => {
          return [
              {
              message: 'Pastikan jumlah fiber sudah sesuai!',
              dismissAfter: 10,
              },
          ]
      }},
      // cardAttrs: { default() { return 'test' } },
    },
    data() {
        return {
            title: this.lodash.startCase('nota bongkar'),
            successModalShow: false,
            modelId: null,
        }
    },
    mounted() {
        this.fetchModel();
    },
    computed: {
        items() {
            return [
                {
                    text: this.lodash.startCase(this.$t('unloads.plural')),
                    href: "/unload",
                },
                {
                    text: this.model && this.model.id ? this.model['name'] : this.$route.params.key,
                    href: `/unload/${this.$route.params.key}`,
                    active: true,
                },
                {
                    text: this.$t('Edit'),
                    href: `/unload/${this.$route.params.key}/edit`,
                    active: true,
                },
            ]
        }
    },
    methods: {
        fetchModel() {
            this.loading = true;
            this.$axios.get(`/v2/sale_orders/${this.$route.params.key}`, {
                params: {
                    include: [
                        "creator",
                        "customer",
                        "files",
                        "sale_additional_items",
                        "sale_items.trip_items",
                        "ticketable.ticket",
                        "trip.driver",
                        "trip.vehicle",
                        "odoo_sale_order",
                    ].join(",")
                }
            }).then((response) => {
                const { data: { data } } = response;
                const saleItems = data.sale_items || [];
                const saleAdditionalItems = data.sale_additional_items || [];
                const isBilled = data.odoo_sale_order?.invoice_status === 'invoiced';
                const purchase_order_ids = [...new Set(saleItems.filter((item) => item.purchase_item).map(v => v.purchase_item.purchase_order_id))];
                let purchase_order_id = ""
                purchase_order_ids.forEach((id) => {
                    purchase_order_id += id + ","
                })
                this.model = {
                    ...data,
                    _denyDelete: isBilled,
                    sale_items: this.applySaleItemRelationTypes(saleItems),
                    purchase_order_ids,
                    purchase_order_id,
                    actual_sale_items: saleItems.filter((item) => !item.purchase_item),
                    sale_additional_fees: saleAdditionalItems.filter(v => v.total >= 0),
                    sale_discounts: saleAdditionalItems.filter(v => v.total < 0).map(v => ({ ...v, total: Math.abs(v.total) })),
                    files: data.files ? data.files.map((v) => {
                        let file = { ...v, preview: v.url, format: v.extension}
                        delete file.path
                        return file
                    }) : [],
                };
                this.model.sale_paid_by_jala = saleAdditionalItems.filter(v => v.paid_by == 'jala').map((v) => ({...v, total: Math.abs(v.total)}));
                this.model.sale_paid_by_partner = saleAdditionalItems.filter(v => v.paid_by == 'partner').map((v) => ({...v, total: Math.abs(v.total)}));
              const defaultPaidByJala = [
                {
                  name: 'Diskon',
                  total: 0,
                  disabled: true,
                  paid_by: 'jala',
                  options: {show_markup_margin_checkbox: true}
                },
                {
                  name: 'Biaya Percepatan',
                  total: 0,
                  disabled: true,
                  paid_by: 'jala',
                },
              ];
                const defaultPaidByPartner = [
                    { name: 'Diskon', total: 0, disabled: true, paid_by: 'partner' },
                    { name: 'PPH 22', total: 0, disabled: true, paid_by: 'partner' },
                    { name: 'Moulting', total: 0, disabled: true, paid_by: 'partner' },
                ];
                if (this.model.sale_paid_by_jala.length == 0) {
                    this.model.sale_paid_by_jala = defaultPaidByJala;
                }else{
                    defaultPaidByJala.forEach((item) => {
                        const index = this.model.sale_paid_by_jala.findIndex(v => v.name == item.name);
                        if (index >= 0) {
                            this.model.sale_paid_by_jala[index].disabled = true;
                        }
                    })
                }
                if (this.model.sale_paid_by_partner.length == 0) {
                    this.model.sale_paid_by_partner = defaultPaidByPartner;
                }else{
                    defaultPaidByPartner.forEach((item) => {
                        const index = this.model.sale_paid_by_partner.findIndex(v => v.name == item.name);
                        if (index >= 0) {
                            this.model.sale_paid_by_partner[index].disabled = true;
                        }
                    })
                }

                if(this.model.is_draft){
                  this.cardAttrs = {
                    title: "UPGRADE NOTA TIMBANG"
                  }
                }

                return response;
            }).catch((error) => this.failedAlert(error)).finally(() => this.loading = false)
        },
        update(value) {
            return this.$axios.post(`/v2/sale_orders/${this.$route.params.key}`, (
                serialize(SaleOrderService.transformToUpdatePayload(value), { indices: true, booleansAsIntegers: true })
            ))
        },
        delete() {
            return this.$axios.delete(`/sale_orders/${this.$route.params.key}`)
        },
        deleteSuccessAlert() {
            return Swal.fire({
                title: this.$t('Deleted') + '!',
                text: this.$t(`You deleted {something} {id}`, {something: this.$t('unloads.plural'), id: this.$route.params.key}),
                type: 'success',
                confirmButtonClass: 'btn btn-success btn-fill',
                buttonsStyling: false
            })
        },
        handleUpdate(value) {
            this.updating = true;
            this.update(value)
                .then((res) => {
                    this.modelId = res.data.data.id
                    this.isEditing = false
                    this.showSuccessModal()
                })
                .catch((error) => this.failedAlert(error))
                .finally(() => { this.updating = false; })
        },
        showSuccessModal() {
            this.successModalShow = true
        },
        handleCloseClickSuccessModal() {
            this.successModalShow = false
            this.$router.push({ name: 'unload.index' })
        },
      applySaleItemRelationTypes(saleItems) {
        let tempSaleItems = saleItems.map((item) => {
          let groupPartialItem = saleItems.filter(({trip_items}) => this.lodash.isEqual(trip_items.map(tripItem => tripItem.id), item.trip_items.map(tripItem => tripItem.id)))
          let sameTripItemCount = groupPartialItem.length;
          let is_merge_item = item.trip_items.length > 1
          let is_partial_item = sameTripItemCount > 1
          item.trip_item_ids = item.trip_items.map(({id}) => id)
          item.product_code = item.trip_items[0].product_code

          if (is_merge_item) {
            item.trip_item_relation_type = 'merge'
            item.disabled_checkbox = true
            item.show_partial_button = false
          } else if (is_partial_item) {
            item.trip_item_relation_type = 'partial'
            item.is_first_partial_item = item.id === groupPartialItem[0].id
            item.disabled_checkbox = true
            item.show_partial_button = item.id !== groupPartialItem[0].id
            item.partial_item_length = sameTripItemCount
          } else {
            item.trip_item_relation_type = 'single'
            item.show_partial_button = true
          }

          return item;
        })

        return tempSaleItems.sort((a, b) => Math.min(...a.trip_item_ids) - Math.min(...b.trip_item_ids))
      },
    }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <success-to-update-modal
        v-model="successModalShow"
        :name="$t('unloads.singular')"
        :model-id="modelId"
        action="updated"
        @close-clicked="handleCloseClickSuccessModal"
    />
    <div class="row">
      <model-edit class="col-12" :loading="loading" :updating="updating" :deleting="deleting" v-bind="$props"
        v-model="model" :errors.sync="errors" :key="getModelKey()" @back-click="handleBack" @update-click="handleUpdate"
        @delete-click="handleDelete" @model-changed="handleModelChanged">
      </model-edit>
    </div>
  </Layout>
</template>
